export var Typographies;
(function (Typographies) {
    Typographies["H1_HEADING"] = "h1Heading";
    Typographies["H2_HEADING"] = "h2Heading";
    Typographies["H3_HEADING"] = "h3Heading";
    Typographies["H4_HEADING"] = "h4Heading";
    Typographies["H5_HEADING"] = "h5Heading";
    Typographies["H6_HEADING"] = "h6Heading";
    Typographies["H7_HEADING"] = "h7Heading";
    Typographies["SUBTITLE"] = "subtitle";
    Typographies["BUTTON"] = "button";
    Typographies["BODY1"] = "body1";
    Typographies["BODY2"] = "body2";
    Typographies["CAPTION"] = "caption";
    Typographies["LINK"] = "link";
    Typographies["TOAST_CONTENT"] = "toastContent";
    Typographies["TOAST_TITLE"] = "toastTitle";
    Typographies["TAB"] = "tab";
    Typographies["TAB_ACTIVE"] = "tabActive";
})(Typographies || (Typographies = {}));
var getThemeTypography = function (typography) {
    return function (_a) {
        var theme = _a.theme;
        return theme.typography[typography];
    };
};
export default getThemeTypography;
